import React, { Fragment } from 'react';
import {
    Create,
    Datagrid,
    DateField,
    Edit,
    FormDataConsumer,
    List,
    ReferenceInput,
    ReferenceField,
    required,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput,
    DateInput,
    useQueryWithStore,
    AutocompleteInput,
    useDataProvider,
    useNotify,
    Button,
    Show,
    SimpleShowLayout,
    NumberField,
    Filter
} from 'react-admin';
import { useForm } from 'react-final-form';
import { RedirectToolbar } from './common';
import DefaultListActions, { AddItemButton, Empty } from './common';
import AddIcon from '@material-ui/icons/Add';
import { Link } from 'react-router-dom';
import exporterCommon from '../import/exporterCommon';

const eventTypeChoices = [
    { id: 'Suspension', name: 'Suspension' },
    { id: 'Promotion', name: 'Promotion' },
    { id: 'Termination', name: 'Termination' },
    { id: 'ReEmployment', name: 'ReEmployment' }
];

const EventFilter = props => (
    <Filter {...props}>
        <AutocompleteInput label="Event Name" source="description" alwaysOn />
        <ReferenceInput perPage={1000} label="Employee Name" emptyText="All Employees" allowEmpty source="employeeId" reference="employees" alwaysOn >
            <AutocompleteInput allowEmpty={true} optionText={(record) => record.fullname ? (record.orgID || '') + " " + record.fullname : "All Employees"} options={{ type: 'search' }} />
        </ReferenceInput >
    </Filter>
);

// Custom exporter for events to include employee full name
export const eventExporter = (posts, fetchRelatedRecords, dataProvider) => {
    if (!posts || !posts.length) {
        // No events to export
        var jsonExport = require('jsonexport/dist');
        jsonExport([], function(err, csv) {
            if (err) {
                console.error(err);
                return;
            }
            var downloadCSV = require('react-admin').downloadCSV;
            downloadCSV(csv, 'events');
        });
        return;
    }
    // Fetch all unique employeeIds from events
    var employeeIds = posts.map(function(post) { return post.employeeId; });
    // Remove duplicates and falsy values
    employeeIds = employeeIds.filter(function(id, index) { return id && employeeIds.indexOf(id) === index; });

    if (!employeeIds.length) {
        // No employeeIds, export with empty employee names
        var dataNoEmp = posts.map(function(post) {
            return {
                Employee: '',
                EventType: post.eventType,
                StartDate: post.startDate,
                EndDate: post.endDate,
                Description: post.description
            };
        });
        var jsonExport2 = require('jsonexport/dist');
        jsonExport2(dataNoEmp, function(err, csv) {
            if (err) {
                console.error(err);
                return;
            }
            var downloadCSV = require('react-admin').downloadCSV;
            downloadCSV(csv, 'events');
        });
        return;
    }

    // Use dataProvider directly
    dataProvider.getMany('employees', { ids: employeeIds }).then(function(response) {
        var employees = {};
        if (response && response.data) {
            for (var i = 0; i < response.data.length; i++) {
                employees[response.data[i].id] = response.data[i];
            }
        }
        var data = posts.map(function(post) {
            var employee = employees[post.employeeId] || {};
            return {
                Employee: employee.fullname || '',
                EventType: post.eventType,
                StartDate: post.startDate,
                EndDate: post.endDate,
                Description: post.description
            };
        });
        // Use jsonexport to export CSV
        var jsonExport = require('jsonexport/dist');
        jsonExport(data, function(err, csv) {
            if (err) {
                console.error(err);
                return;
            }
            var downloadCSV = require('react-admin').downloadCSV;
            downloadCSV(csv, 'events');
        });
    });
};

export const EventList = props => (
    <List empty={<Empty />} exporter={eventExporter} actions={<DefaultListActions />} filters={<EventFilter />} {...props}>
        <Datagrid rowClick="edit">
            <ReferenceField label="Employee" source="employeeId" reference="employees">
                <TextField source="fullname" />
            </ReferenceField>
            <TextField source="eventType" />
            <DateField source="startDate" />
            <DateField source="endDate" />
            <TextField source="description" />
        </Datagrid>
    </List>
);

export const EventEdit = props => {
    var employeeId = null;
    if (props.location && props.location.search) {
        var params = props.location.search.replace('?', '').split('&');
        for (var i = 0; i < params.length; i++) {
            var pair = params[i].split('=');
            if (pair[0] === 'employeeId') {
                employeeId = pair[1];
            }
        }
    }
    var redirect = employeeId ? '/employees/' + employeeId + '/show/events' : 'list';

    return <Edit {...props}>
        <SimpleForm redirect={redirect} toolbar={<RedirectToolbar />}> 
            <EventForm employeeId={employeeId} />
        </SimpleForm>
    </Edit>;
};

const EventForm = ({ formData, employeeId, ...rest }) => {
    var form = useForm();
    console.log(employeeId)
    return (
        <Fragment>
            <ReferenceInput
                {...rest}
                source="employeeId"
                perPage={1000}
                reference="employees"
                validate={required()}
                disabled={!!employeeId}
            >
                <SelectInput
                    optionText={(record) => record.fullname ? (record.orgID || '') + " " + record.fullname : "All Employees"}
                    options={{ type: 'search' }}
                    allowEmpty={true}
                    emptyText="All Employees"
                    disabled={!!employeeId}
                />
            </ReferenceInput>
            <SelectInput source="eventType" choices={eventTypeChoices} validate={required()} />
            <DateInput source="startDate"  options={{ format: 'DD/MM/YYYY' }} />
            <DateInput source="endDate" options={{ format: 'DD/MM/YYYY' }} />
            <TextInput source="description" multiline rows={3} />
        </Fragment>
    );
};

export const EventCreate = props => {
    var employeeId = null;
    if (props.location && props.location.search) {
        var params = props.location.search.replace('?', '').split('&');
        for (var i = 0; i < params.length; i++) {
            var pair = params[i].split('=');
            if (pair[0] === 'employeeId') {
                employeeId = pair[1];
            }
        }
    }
    var redirect = employeeId ? '/employees/' + employeeId + '/show/events' : 'list';
    console.log(employeeId)
    return <Create {...props}>
        <SimpleForm redirect={redirect} initialValues={{employeeId: employeeId}}>
            <EventForm employeeId={employeeId} />
        </SimpleForm>
    </Create>;
};

export const EventShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <ReferenceField label="Employee" source="employeeId" reference="employees">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="eventType" />
            <DateField source="startDate" />
            <DateField source="endDate" />
            <TextField source="description" />
        </SimpleShowLayout>
    </Show>
);

export const AddNewEventButton = ({ record }) => (
    <Button
        component={Link}
        to={{
            pathname: '/events/create',
            search: '?employeeId=' + record.id
        }}
        label="Add Event"
    >
        <AddIcon />
    </Button>
); 